import WsService from "./WsService";

const ENDPOINT_BASE = "/admin/contact-us";

export default class ContactUsService {

    static submitRequest(contactUsRequest){

        let headers = {
            "Authorization" : ""
        };

        return WsService.postWithHeaders(ENDPOINT_BASE, contactUsRequest, 200, headers).then(
            response => {
                return response;
            }
        );
    }

}